// extracted by mini-css-extract-plugin
export var container = "landing-module--container--YdaaF";
export var contentWrapper = "landing-module--content-wrapper--hWQIb";
export var title = "landing-module--title--gmLBo";
export var subtitle = "landing-module--subtitle--J6Umw";
export var registration = "landing-module--registration--j85Pa";
export var btn = "landing-module--btn--DlX4l";
export var listWrapper = "landing-module--list-wrapper--kl-ba";
export var mediaWrapper = "landing-module--media-wrapper--mODNX";